
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from 'rxjs';
import { PlanWithJobRequest } from "../../domain";
import { PlansRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class EditPlanWithJobUsecase implements UseCase<PlanWithJobRequest, boolean> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(params: PlanWithJobRequest): Observable<boolean> {
    return this.planRepository.editPlanWithJob(params);
  }

}